module.exports = __webpack_public_path__ + "4cd2f4c3f4b46cad5868bfb48661378f.jpg";